export const redirectToExternalUrl = (url: string): void => {
  // eslint-disable-next-line no-undef
  window.location.replace(url)
}
